import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/icons/plus.svg'
import _imports_1 from '@/assets/icons/payments/generic.svg'
import _imports_2 from '@/assets/icons/payments/ach.svg'
import _imports_3 from '@/assets/icons/delete.svg'
import _imports_4 from '@/assets/icons/checkmark-circle-green.svg'
import _imports_5 from '@/assets/icons/checkmark-circle.svg'


const _hoisted_1 = { class: "w-3/4" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 1,
  class: "flex flex-row"
}
const _hoisted_4 = { class: "w-2/3 mr-2" }
const _hoisted_5 = { class: "flex flex-col bg-white rounded-2xl pt-8" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "table-general text-center" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "th-default" }, "Service"),
    /*#__PURE__*/_createElementVNode("th", { class: "th-default" }, "Date"),
    /*#__PURE__*/_createElementVNode("th", { class: "th-default" }, "Amount"),
    /*#__PURE__*/_createElementVNode("th", { class: "th-default" }, "Invoice (PDF)")
  ])
], -1)
const _hoisted_9 = { class: "td-spacings" }
const _hoisted_10 = { class: "td-bubble-default capitalize" }
const _hoisted_11 = { class: "td-spacings" }
const _hoisted_12 = { class: "td-bubble-default" }
const _hoisted_13 = { class: "td-spacings" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 1,
  class: "td-bubble-black"
}
const _hoisted_16 = ["href"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("button", { class: "btn-text" }, "View invoice", -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "flex flex-col w-1/3 ml-2" }
const _hoisted_20 = { class: "flex flex-col bg-white rounded-2xl p-8" }
const _hoisted_21 = {
  key: 0,
  class: "flex flex-col bg-white rounded-2xl p-8"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "text-lg font-semibold" }, "Next billing date", -1)
const _hoisted_23 = { class: "flex flex-row items-end mt-4" }
const _hoisted_24 = {
  key: 0,
  class: "text-3xl font-bold"
}
const _hoisted_25 = {
  key: 1,
  class: "text-3xl font-bold"
}
const _hoisted_26 = { class: "font-bold uppercase ml-2" }
const _hoisted_27 = { class: "text-gray-500 text-sm mt-4" }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { class: "flex flex-col bg-white rounded-2xl p-8 mt-4" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "text-g font-semibold" }, "Payment methods", -1)
const _hoisted_31 = {
  key: 0,
  class: "space-x-3 btn-filled-sm flex flex-row items-center disabled:opacity-50 justify-between truncate text-base bg-primary rounded-full transition duration-150 ease-in disabled:cursor-not-allowed"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
  /*#__PURE__*/_createElementVNode("span", { class: "ml-1" }, "Add payment method")
], -1)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "btn-filled-sm mt-4 flex flex-row justify-center" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
  /*#__PURE__*/_createElementVNode("span", { class: "text-sm ml-2" }, "Add payment method")
], -1)
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_38 = { class: "flex flex-row items-center" }
const _hoisted_39 = ["src"]
const _hoisted_40 = {
  key: 1,
  src: _imports_1,
  class: "h-10 mr-2"
}
const _hoisted_41 = { class: "font-semibold capitalize" }
const _hoisted_42 = { class: "text-gray-500 mt-2" }
const _hoisted_43 = {
  key: 0,
  class: "text-gray-500 mt-2"
}
const _hoisted_44 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_45 = { class: "flex flex-row items-center" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("img", {
  class: "h-10 mr-2",
  src: _imports_2,
  alt: ""
}, null, -1)
const _hoisted_47 = { class: "font-semibold capitalize" }
const _hoisted_48 = { class: "text-gray-500 mt-2" }
const _hoisted_49 = { class: "text-gray-500 mt-2" }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1)
const _hoisted_52 = [
  _hoisted_51
]
const _hoisted_53 = { key: 2 }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_4 })
], -1)
const _hoisted_55 = [
  _hoisted_54
]
const _hoisted_56 = { key: 3 }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_4 })
], -1)
const _hoisted_58 = [
  _hoisted_57
]
const _hoisted_59 = { key: 4 }
const _hoisted_60 = ["onClick"]
const _hoisted_61 = /*#__PURE__*/_createElementVNode("img", { src: _imports_5 }, null, -1)
const _hoisted_62 = [
  _hoisted_61
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_ErrorState = _resolveComponent("ErrorState")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_DateFormatter = _resolveComponent("DateFormatter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Spinner, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.error)
            ? (_openBlock(), _createBlock(_component_ErrorState, { key: 0 }))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    (_ctx.invoices.length === 0)
                      ? (_openBlock(), _createBlock(_component_EmptyState, {
                          key: 0,
                          name: "invoices",
                          class: "pb-8"
                        }))
                      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createElementVNode("table", _hoisted_7, [
                            _hoisted_8,
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoices, (invoice, i) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: i,
                                  class: "tr-default mx-2"
                                }, [
                                  _createElementVNode("td", _hoisted_9, [
                                    _createElementVNode("div", _hoisted_10, _toDisplayString(invoice.transaction_type), 1)
                                  ]),
                                  _createElementVNode("td", _hoisted_11, [
                                    _createElementVNode("div", _hoisted_12, [
                                      _createVNode(_component_DateFormatter, {
                                        date: invoice.created_at
                                      }, null, 8, ["date"])
                                    ])
                                  ]),
                                  _createElementVNode("td", _hoisted_13, [
                                    (invoice.parent?.id)
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 0,
                                          class: "td-bubble-black cursor-pointer",
                                          onClick: ($event: any) => (_ctx.$router.push(`/payroll/${invoice.parent.id}`))
                                        }, " $" + _toDisplayString((invoice.amount / 100).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })), 9, _hoisted_14))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_15, " $" + _toDisplayString((invoice.amount / 100).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })), 1))
                                  ]),
                                  _createElementVNode("td", null, [
                                    (invoice.parent)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 0,
                                          href: 
                          invoice.parent.url
                            ? invoice.parent.url
                            : invoice.invoice_url
                        
                                        }, _hoisted_18, 8, _hoisted_16))
                                      : _createCommentVNode("", true)
                                  ])
                                ]))
                              }), 128))
                            ])
                          ])
                        ]))
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    (_ctx.nextPayment.exchange_rate > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          _hoisted_22,
                          _createElementVNode("div", _hoisted_23, [
                            (_ctx.currency === 'usd')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_24, " $" + _toDisplayString((_ctx.nextPayment.amount / 100).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })), 1))
                              : _createCommentVNode("", true),
                            (_ctx.currency === 'mxn')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_25, " $" + _toDisplayString((
                      (_ctx.nextPayment.amount * _ctx.nextPayment.exchange_rate) /
                      100
                    ).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.currency), 1)
                          ]),
                          _createElementVNode("span", _hoisted_27, [
                            _createVNode(_component_DateFormatter, {
                              date: _ctx.nextPayment.date
                            }, null, 8, ["date"])
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                          _createVNode(_component_EmptyState, { name: "next billing periods" })
                        ]))
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _hoisted_30,
                    (_ctx.cardsLoading)
                      ? (_openBlock(), _createBlock(_component_Spinner, { key: 0 }))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          (!_ctx.paymentMethods)
                            ? (_openBlock(), _createElementBlock("button", _hoisted_31, _hoisted_33))
                            : (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                _createElementVNode("button", {
                                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addCard && _ctx.addCard(...args))),
                                  type: "submit"
                                }, _hoisted_36),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paymentMethods, (card, i) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: i,
                                    class: "flex flex-row items-center justify-between bg-background-secondary rounded p-4 mt-8"
                                  }, [
                                    (card.card)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                          _createElementVNode("div", _hoisted_38, [
                                            (
                          card.card.brand === 'visa' ||
                          card.card.brand === 'amex' ||
                          card.card.brand === 'mastercard'
                        )
                                              ? (_openBlock(), _createElementBlock("img", {
                                                  key: 0,
                                                  src: 
                          require(`@/assets/icons/payments/${card.card.brand}.svg`)
                        ,
                                                  class: "h-10 mr-2"
                                                }, null, 8, _hoisted_39))
                                              : (_openBlock(), _createElementBlock("img", _hoisted_40)),
                                            _createElementVNode("span", _hoisted_41, _toDisplayString(card.card.funding) + " " + _toDisplayString(card.type), 1)
                                          ]),
                                          _createElementVNode("span", _hoisted_42, "**** **** **** " + _toDisplayString(card.card.last4), 1),
                                          (card.billing_details.name)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString(card.billing_details.name), 1))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (card.us_bank_account)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                          _createElementVNode("div", _hoisted_45, [
                                            _hoisted_46,
                                            _createElementVNode("span", _hoisted_47, _toDisplayString(card.us_bank_account.bank_name) + " " + _toDisplayString(card.us_bank_account.account_type), 1)
                                          ]),
                                          _createElementVNode("span", _hoisted_48, "********" + _toDisplayString(card.us_bank_account.last4), 1),
                                          _createElementVNode("span", _hoisted_49, _toDisplayString(card.us_bank_account.routing_number), 1)
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("button", {
                                      onClick: ($event: any) => (_ctx.removeCard(card))
                                    }, _hoisted_52, 8, _hoisted_50),
                                    (
                      _ctx.defaultPaymentMethod == card.id && _ctx.defaultPaymentMethod
                    )
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_53, _hoisted_55))
                                      : (card.id == '' && !_ctx.defaultPaymentMethod)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_56, _hoisted_58))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                            _createElementVNode("button", {
                                              onClick: ($event: any) => (_ctx.setDefaultCard(card))
                                            }, _hoisted_62, 8, _hoisted_60)
                                          ]))
                                  ]))
                                }), 128))
                              ]))
                        ], 64))
                  ])
                ])
              ]))
        ]))
  ]))
}